const config = {
  //bottoni canvas
  button_storeLocator: false,
  button_favorite: true,
  button_print: true,
  button_share: false,
  //colori testo e icone
  icon_color: "#000000",
  btn_menu_color: "pink",
  logoImageDemenego: "/images/loghi/demenego.png",
  //controlli filtri etc false per non vederli
  btn_ritornaHome: true,
  btn_darkMode: true,
  frontali_marchio: false,
  frontali_search: true,
  fronatli_tipologia: false,
  frontali_asianFitting: false,
  colori_categories: true,
  colori_finiture: true,
  colori_search: true,
  aste_misure: true,
  aste_material: true,
  aste_finiture: true,
  aste_metalColor: true,
  personalizzazioniAste: true,
  nome_ciliare: true,
  nome_extdx: true,
  nome_extsx: true,
  lenti_stile: true,
  //controlli display modo in cui si vedono le griglie degli item
  //wrap false = carousel
  //wrap true = griglia e scroll in basso
  frontali_wrap: true,
  colori_wrap: true,
  aste_wrap: true,
  lentiSole_wrap: false
};
export default config;